export default __webpack_public_path__ + "locales/pl/Article.json?hash=63bf3db6b13fd1a7a40024badc3c1f3b";